import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../../../infrastructure/config';
import { ResetPasswordRequestModel } from '../../../models/requestModels/password/resetPasswordRequestModel';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {


  private userChangePasswordURL : string = Config.api + "user/change_password";

  constructor(private httpClient: HttpClient) { }

  changePassword(resetPasswordRequestModel: ResetPasswordRequestModel) {
    return this.httpClient.patch(this.userChangePasswordURL, resetPasswordRequestModel);
  }
}
